import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';

export const MaybeEmptyFieldValues: (emptyLabel?: string) => TypeaheadEntry[] = (
  emptyLabel: string = 'common.noPredefinedValue'
) => [
  {
    label: emptyLabel,
    value: 'empty',
  },
  {
    label: 'switch.no',
    value: false,
  },
  {
    label: 'switch.yes',
    value: true,
  },
];

export function mergeMaybeEmptyField(
  model: Record<any, any>,
  value: boolean | 'empty',
  attribute: string
): void {
  model[attribute] = value === 'empty' ? null : value;
}

export function parseMaybeEmptyField(value?: boolean): boolean | 'empty' {
  return value ?? 'empty';
}
